import { render } from "./Index.vue?vue&type=template&id=1eb2edf4&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=1eb2edf4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\projects\\p2ipo-system-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb2edf4"]])

export default __exports__